  import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Collapse,Popconfirm,Modal, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker,message   } from 'antd';
import {  EditOutlined,SafetyCertificateOutlined,DeleteOutlined } from '@ant-design/icons';
import Pagination from "react-js-pagination";

const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			value: '',
			checkedBoxes: [],
			school_list: [],
			program_list: [],
			academic_year_: [],
			total_self: 0,
			total_franchise: 0,
			is_show: 0,
			aToken: '',
			main_menu: '',
			sub_menu: '',
			academic_year: '',
			student_type: '',
			name: '',
			total_count:0,
			program_id:'',
			page_name:'',
			name:'',
			active_tab:'',
			tab_name:'',
			map_student:[],
			page: 1,
			show_map_model: false,
		}
		this.onChangePage = this.onChangePage.bind(this);
		this.change_year = this.change_year.bind(this);
		this.handleSizeChange = this.handleSizeChange.bind(this);
	}
	
	onChangePage=(pageNumber)=>{
	    this.setState({ page : pageNumber });
	    setTimeout(() => {
		 this.checkData();
	    }, 500);
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		var url=window.location.pathname.split('/');
		this.setState({ 
			active_tab : url[2],
			tab_name : this.props.match.params.text,
		});
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
			var date = new Date().toLocaleString("en-US", {timeZone: "Asia/Kolkata"});
			const new_acad = (new Date().getFullYear())+'-'+ (new Date().getFullYear()+1);
			
			var storedArray = JSON.parse(localStorage.getItem("schoolData"))
			var permission = storedArray['data'][0]['permission'];
			var user_type = storedArray['data'][0]['type'];
			setTimeout(() => {
				this.setState({ 
					user_id : storedArray['data'][0]['user_id'],
					permission : permission,
					user_type : user_type,
				});
			}, 50);
			
		}
		var user_id = storedArray['data'][0]['user_id'];
		var school_id = storedArray['data'][0]['school_id'];
		var type = storedArray['data'][0]['type'];
		var app = {user_id : user_id,school_id:school_id,type:type}
		getData('auth/get_login_token',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					var aToken= result['data'];
					localStorage.setItem("aToken",aToken);
					var main_link = 'https://erp.kidzonia.co.in/panel/admin';
					var dayplan_link = 'https://erp.kidzonia.co.in/panel/dayplan';
					this.setState({
						main_link: main_link,
						dayplan_link: dayplan_link,
						aToken:aToken
					});
				}
				else{
					var aToken='null';
					localStorage.setItem("aToken",aToken);
					var main_link = 'https://erp.kidzonia.co.in/panel/admin';
					var dayplan_link = 'https://erp.kidzonia.co.in/panel/dayplan';
					this.setState({
						main_link: main_link,
						dayplan_link: dayplan_link,
						aToken:aToken
					});
				}
			}
		});
		getData('common/get_academic_year',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							academic_year_: result['data'],
						});
					}else{
						this.setState({
							academic_year_: [],
						});
					}
				}
			});	
		getData('erp/new_program_list',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					setTimeout(() => {
						this.setState({
							program_list: result['data'],
						});
					}, 100);	
				}else{
					this.setState({
						program_list: [],
						
					});
				}
				}
			});
			setTimeout(() => {
				this.checkData();
			}, 100);
	}
	
	openQuantity(e){
		this.setState({ program_id: e.target.value });
	}  
	
	handleSubmit(e){
		setTimeout(() => {
			this.checkData();
		}, 50);
	} 
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var msg_type = this.props.match.params.text;
			var app = {user_id : user_id,school_id:school_id,page:this.state.page,msg_type:msg_type,type:this.state.academic_year}
			getData('erp/email_whatsapp_report_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
							total_count: result['total_count'],
							page_name: result['page_name'],
							is_show: 1,
						});
					}else{
						this.setState({
							school_list: [],
							total_count: 0,
							page_name: '',
							is_show: 1,
						});
					}
				}
			});
	}
    }
	
	change_year(event){
	this.setState({academic_year: event.target.value});
	}
	change_type(event){
	this.setState({student_type: event.target.value});
	}
	change_admission_form(event){
	this.setState({admission_form: event.target.value});
	}
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	};
	
	toggleChecked = () => {
		const checkedBoxes = [...this.state.checkedBoxes];
		var checkboxes = document.getElementsByName('checked_id[]');
		for (var i = 0; i < checkboxes.length; i++) {
			checkedBoxes.push(checkboxes[i].value);	
		}
		this.setState({checkedBoxes,checked:true});
		console.log(checkedBoxes);
    }
	
	toggleUnChecked = () => {
		this.setState({checkedBoxes:[],checked:false});
    }
  
	handleCheckbox = (e, s) => {
		const checkedBoxes = [...this.state.checkedBoxes];
		if(e.target.checked) {
			checkedBoxes.push(s)
		} else {
			const index = checkedBoxes.findIndex((ch) => ch === s);
			checkedBoxes.splice(index, 1);
		}
		this.setState({checkedBoxes,selection_count:checkedBoxes.length});
	}
	
	updatePositions=(p_array)=>{
		this.setState({ map_student: p_array, show_map_model:true })
	}
	
		
	handleOk = e => {
		this.setState({
			show_map_model: false,
		})
	}

	handleCancel = e => {
		this.setState({
			show_map_model: false,
		})
	}
  

	render()

	{
	const {aToken}=this.state;
	const { size } = this.state;
	
	const radioStyle = {
		  display: 'block',
		  height: '30px',
		  lineHeight: '30px',
		};				
					
		return (
			<>
				
				<Modal 
				 title="Student List"
				 visible={this.state.show_map_model}
				 className="map_model"
				 onOk={this.handleOk}
				 onCancel={this.handleCancel}
				>
					<div class="student_box">
						{this.state.map_student.map((list,index) => (
							  <div class="student_list">
							  {index+1}. {list}
							  </div>
						))}
					</div>
				</Modal>
			
				<div class="row bred">
					<div class="col-md-12">
						<div class="card">
							<div class="card-body">
								<h4 class="page-title"> 
									<i class="mdi mdi-apple-keyboard-command title_icon"></i> <span >{this.props.match.params.text}</span>
									<div class="breadcrumb-wrapper">
										<ol class="breadcrumb">
											<li class="breadcrumb-item">
												<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
												<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
												</a>
											</li>
											<li class="breadcrumb-item">  <span >{this.props.match.params.text}</span></li>
										</ol>
									</div>
								</h4>
							</div>
						</div>
					</div>
				</div>
				
				<div class="row">
					<div class="card-body">
						<ul class="nav nav-tabs nav-tabs-solid">
							<li class="nav-item"><a href={`${process.env.PUBLIC_URL}/report/whatsapp`} class={`nav-link ${this.state.active_tab == 'whatsapp' && 'active'}`}>Whatsapp  </a></li>
							<li class="nav-item"><a href={`${process.env.PUBLIC_URL}/report/email`} class={`nav-link ${this.state.active_tab == 'email' && 'active'}`} >Email  </a></li>
						</ul>
					</div>
				</div>
				
				<div class="row">
					<div class="col-md-12">
					<div class="card">
					<div class="card-body">
						
						<div class="row">
						<div class="col-md-2">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}><b>Type</b></label>
								<select  onChange={this.change_year} className="form-control changeSchool" value={this.state.academic_year}>
									<option value=''>All</option>
										<option value="enquiry">Enquiry</option>
										<option value="student">Student</option>
								</select>
							</div>
						</div>
						
						<div class="col-md-2">
							<div class="form-group">
								<label  style={{paddingTop: '8px'}}>&nbsp;</label>
								 <Button className="btn btn-primary mr-2" style={{display: 'block'}} id="submit_btn" onClick={this.handleSubmit.bind(this)} >Apply</Button>
							</div>
						</div>
						
						</div>
						
					</div>
					</div>
					</div>
				</div>
				
				
                <div class="">
                  <div class="row">
                     <div class="col-lg-12 mb-3">
					 <div class="card">
						<div class="card-body">
						<div class="row mb-10">
						<div class="col-sm-4 col-12 text-left  enquiry-btn mt-10">
							<h4 class="header-title mt-5px">Total : {this.state.total_count}</h4>
						</div>
						<div class="col-sm-8 col-12 text-right  enquiry-btn mt-5px">
								
						</div>
						</div>
						
                        <div class="table-responsive">
                           <table class="table table-striped table-bordered table-hover">
                              <thead>
                                 <tr>
									
                                    <th>#</th>
                                    <th>Added Date</th>
									<th>Send By</th>
									<th>Type</th>
									<th>{this.state.tab_name == 'whatsapp' ? ('Template Name'):('Subject ')}</th>
                                    <th>Action</th>
                                 </tr>
                              </thead>
                              <tbody>
							  {(this.state.school_list.length == 0 && this.state.is_show == 1) && (<><tr><td colspan="12" class="text-center">No Report Found</td></tr></>)}
							  {(this.state.school_list.length == 0 && this.state.is_show == 0) && (<><tr><td colspan="12" class="text-center">Please Wait While Loading</td></tr></>)}
							  {this.state.school_list.map((list,index) => (
                                 <tr>
									
									<td>{index+1}</td>
                                    <td>{list.added_date}</td>
                                    <td>{list.send_by}</td>
                                    <td>{list.type}</td>
                                    <td>{list.title}</td>
                                    <td>
										<div class="dropright dropright">
											<button type="button" class="btn btn-sm btn-outline-primary btn-rounded btn-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
												<i class="mdi mdi-dots-vertical"></i>
											</button>
											<ul class="dropdown-menu">
												<li><a href="#" class="dropdown-item" onClick={this.updatePositions.bind(this,list.name)} ><EditOutlined /> Student List</a></li>
											</ul>
										</div>
                                    </td>
                                 </tr>
								 ))}
                                
                              </tbody>
                           </table>
						    <div class="fl-right">
								<Pagination
									activePage={this.state.page}
									itemsCountPerPage={10}
									totalItemsCount={this.state.total_count}
									pageRangeDisplayed={3}
									onChange={this.onChangePage.bind(this)}
								/>
							</div>
							
                        </div>
                        </div>
                        </div>
                     </div>
                  </div>
               </div>
			   </>
		) 
	} 
}
export default Index;
